import React from "react";
import Seo from "../components/site/Seo";
import { Container, SectionHeading, Eyebrow, PrimaryButton } from "../components/site/Ui";
import { BUSINESS_TYPES } from "../data/site";
import { useLang } from "../lib/LangContext";


export default function ForBusinesses() {
  const { tr } = useLang();
  return (
    <>
      <Seo
        title="For businesses — restaurants, cafés, salons, barbers, gyms and more"
        description="Social media content for restaurants, cafés, beauty salons, barbers, gyms and automotive businesses in the Netherlands. See what PostMint creates for your industry."
        path="/for-businesses"
      />

      <section className="mesh-warm" data-testid="business-hero">
        <Container className="py-16 lg:py-20">
          <Eyebrow>{tr("For Businesses")}</Eyebrow>
          <h1 className="mt-5 max-w-4xl text-4xl font-extrabold leading-tight text-slate-900 sm:text-5xl lg:text-6xl">
            {tr("Made for businesses that have better things to do than make Instagram posts.")}
          </h1>
        </Container>
      </section>

      <section className="py-16 sm:py-20">
        <Container className="space-y-6">
          {BUSINESS_TYPES.map((b, i) => (
            <article
              key={b.id}
              data-testid={`business-section-${b.id}`}
              className={`grid items-center gap-8 overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 soft-shadow sm:p-8 lg:grid-cols-2 ${
                i % 2 === 1 ? "lg:[&>img]:order-first" : ""
              }`}
            >
              <div>
                <h2 className="font-display text-2xl font-bold text-slate-900 sm:text-3xl">{tr(b.name)}</h2>
                <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-slate-400">{tr("Content examples")}</p>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {b.items.map((item) => (
                    <li
                      key={item}
                      className="rounded-full bg-[#FFF3EF] px-3 py-1.5 text-sm font-medium text-[#B93615]"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
              <img
                src={b.image}
                alt={`${b.name} business photography example`}
                loading="lazy"
                className="h-64 w-full rounded-2xl object-cover lg:h-72"
              />
            </article>
          ))}
        </Container>
      </section>

      <section className="border-t border-slate-200 bg-white py-20" data-testid="business-cta">
        <Container>
          <SectionHeading
            align="center"
            title="Don't see your industry?"
            body="PostMint can work with almost any business that needs regular social media content."
          />
          <div className="mt-8 flex justify-center">
            <PrimaryButton to="/contact" testId="business-tell-us-button">
              Tell Us About Your Business
            </PrimaryButton>
          </div>
        </Container>
      </section>
    </>
  );
}
